import { Controller } from "@hotwired/stimulus"

// Replaces tailwindcss-stimulus-components' Toggle for the mobile nav. That one
// shows and hides the panel but never touches aria-expanded, so the button
// either lied about its state (it was hardcoded "false") or announced none at
// all. Screen readers need to know whether the menu is open.
export default class extends Controller {
  static targets = ["panel", "trigger"]

  connect() {
    this.sync()
  }

  toggle(event) {
    event.preventDefault()
    this.panelTarget.classList.toggle("hidden")
    this.sync()
  }

  sync() {
    const expanded = !this.panelTarget.classList.contains("hidden")

    this.triggerTargets.forEach((trigger) => {
      trigger.setAttribute("aria-expanded", String(expanded))
    })
  }
}
